/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Box } from '@material-ui/core';
import Lottie from 'react-lottie';
import animationData from './heartbeat-loader.json';

interface HeartbeatLoaderProps {
  className?: string;
}

const HeartbeatLoader = ({ className }: HeartbeatLoaderProps) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Box
      className={className}
      aria-label="Loading"
      role="status"
      data-testid="heartbeat-loader"
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="80%"
      height="80%"
    >
      <Lottie options={defaultOptions} />
    </Box>
  );
};

export default HeartbeatLoader;
